import {
  B2Regular,
  enWordKeepAllStyle,
  H10Bold,
  H4Bold,
  H8Regular,
  px2rem,
} from "@moim/common";
import { Svg24BackB } from "@moim/icons";
import styled, { css, FlattenInterpolation } from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
`;
export const Body = styled.div`
  height: 100%;
`;

export const UserWalletAddress = styled(H10Bold)`
  padding: ${px2rem(4)} ${px2rem(16)};
  color: ${props => props.theme.colorV2.colorSet.grey800};
`;

export const BioWrapper = styled.div`
  padding: ${px2rem(8)} ${px2rem(16)};
`;

export const UserBio = styled(B2Regular)`
  color: ${props => props.theme.colorV2.colorSet.grey600};
  white-space: pre-line;
  ${enWordKeepAllStyle}
`;

export const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.div`
  padding: ${px2rem(11)} ${px2rem(16)};
  color: ${props => props.theme.colorV2.colorSet.grey800};
`;

export const ParallaxWrapper = styled.div<{ opacity: string }>`
  opacity: ${props => props.opacity};
  transition: opacity 200ms ease-in-out;
`;
export const AppBarTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const AppBarTitleUsername = styled(H8Regular)`
  color: ${props => props.theme.colorV2.colorSet.fog800};
  margin-left: ${px2rem(8)};
`;

export const ParallaxUsernameWrapper = styled.div`
  flex: 1;
  min-width: 0;
  padding: ${px2rem(8)} ${px2rem(16)};
`;

export const ParallaxUsername = styled(H4Bold)`
  color: ${props => props.theme.colorV2.colorSet.grey800};
`;

export const AppBarStickyWrapperStyle = css`
  background-color: ${props => props.theme.colorV2.primary.main} !important;
`;

export const BackIconButton = styled(Svg24BackB).attrs(props => ({
  size: "s",
  touch: 24,
  role: "button",
  iconColor: props.theme.colorV2.colorSet.fog1000,
}))``;

export const getAppBarStickyStyle = (
  top: number,
  overrideStyle?: FlattenInterpolation<any>,
) => css`
  top: ${px2rem(top)} !important;
  ${overrideStyle};
`;

export const AppBarWrapperStyle = css`
  color: ${props => props.theme.colorV2.colorSet.grey800};
`;
